import { keyframes } from 'styled-components'

export const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const FadeInPartial = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.85;
  }
`
